import { type BrandListItem } from '@shared/types';
import React from 'react';
import BrandItem from './BrandItem';
import * as Styled from './BrandList.style';

type SupportedBrandListProps = {
  brands: BrandListItem[];
  /** Show compact view of the brand list (4 items with tiny paddings per row) */
  isCompact?: boolean;
};

export const BrandList = React.memo(({ brands, isCompact = false }: SupportedBrandListProps) => (
  <Styled.BrandList isCompact={isCompact}>
    {brands.map(brandItem => (
      <Styled.BrandListItem key={brandItem.brand}>
        <BrandItem brand={brandItem} isCompact={isCompact} />
      </Styled.BrandListItem>
    ))}
  </Styled.BrandList>
));

export default BrandList;
